import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import {Button} from 'wobi-web-common/dist/v2/index.js';

import {getImageByAgent} from '../../../../config/agent';

const coffeeImage = getImageByAgent('coffee.svg');
function SecondStep({increaseStep}) {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, padding: '8px 0'}}>
      <img src={coffeeImage} alt='' style={{width: 80, height: 80}} />
      <p style={{
        margin: 0,
        fontSize: theme.typography.pxToRem(15.5),
        color: theme.palette.text.primary,
        lineHeight: 1.6,
        maxWidth: 340,
        textAlign: 'center',
      }}>
        { intl.formatMessage({id: 'unsupported_medical_cases_modal.second_step.text'}) }
      </p>
      <Button
        variant='primary'
        size='lg'
        onClick={increaseStep}
        style={{marginTop: 8}}
      >
        { intl.formatMessage({id: 'unsupported_medical_cases_modal.second_step.button'}) }
      </Button>
    </div>
  );
}

SecondStep.propTypes = {
  increaseStep: PropTypes.func.isRequired,
};

export default SecondStep;
